import SparkApi from "../../api/SparkApi";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import InfoPill from "../InfoPill";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import JsBarcode from "jsbarcode";
import { FaDownload } from "react-icons/fa";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { usePermission } from "../context/PermissionContext";

const Products = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [isScannerVisible, setScannerVisible] = useState(false);
  const { permissionData , userInfo } = usePermission();
  const can_create = permissionData?.Product?.can_create;
  const can_create_inventory = permissionData?.Product_Inventory?.can_create;
  
  const handleScanButton = () => {
    setScannerVisible(true);
  }

  /*---------  Start barcode ----------------*/
  const [barcodeRead, setBarcodeRead] = useState();
  const barcodeRef = useRef({
    timing: 0,
    data: "",
  });

  useEffect(() => {
    const barcodeReaded = () => {
      if (
        barcodeRef.current.data.length > 1 &&
        barcodeRef.current.data.includes("PRO")
      ) {
        setBarcodeRead(barcodeRef.current.data.split("E")[0]);
      }
      barcodeRef.current = { timing: 0, data: "" };
    };

    let timeout;

    const handleKeypress = (e) => {
      const currentTime = e.timeStamp;
      const isWithinInterval = currentTime - barcodeRef.current.timing < 200;

      if (barcodeRef.current.data.length === 0 || isWithinInterval) {
        clearTimeout(timeout);
        barcodeRef.current.data += e.key;
        barcodeRef.current.timing = currentTime;
        timeout = setTimeout(barcodeReaded, 300);
      } else {
        clearTimeout(timeout);
        barcodeRef.current = {
          timing: currentTime,
          data: e.key,
        };
      }
    };

    window.addEventListener("keypress", handleKeypress);

    return () => {
      window.removeEventListener("keypress", handleKeypress);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    if (barcodeRead) {
      fetchProductDetails();
    }
  }, [barcodeRead]);

  const fetchProductDetails = async () => {
    try {
      console.log('barcodeRead-->>' , barcodeRead);
      
      const result = await SparkApi.getProducts(barcodeRead); 
      console.log('get-product-by-barcode-->>' , result);
      if(result.success){
        setProducts(result.records);
      }
		 
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };
  /*---------   End barcode   ------------*/

  //------------------barcode download start------------------------------------
  const BarcodeCell = ({ id, value }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
      if (canvasRef.current) {
        JsBarcode(canvasRef.current, value, {
          width: 1,
          height: 30,
          displayValue: true,
        });
      }
    }, [value]);

    const handleBarcodeDownload = () => {
      if (canvasRef.current) {
        const imageUrl = canvasRef.current.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = imageUrl;
        link.download = `barcode-${id}.png`;
        link.click();
      }
    };

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <canvas ref={canvasRef} />
        <FaDownload
          size={16}
          style={{ cursor: "pointer", color: "#007bff" }}
          onClick={handleBarcodeDownload}
          title="Download Barcode"
        />
      </div>
    );
  };
  //------------------barcode download end------------------------------------

  const fetchProducts = async () => {
    try {
      const result = await SparkApi.getProducts();
      if(result.success){
        setProducts(result.records);
      }
    } catch (error) {
      setProducts([]);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    window.addEventListener("keypress", (e) => {
    });
  }, []);

  const createProducts = () => {
    navigate("/createproduct");
  };

  const capitalizeWords = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const header = [
    {
      title: "Product Name",
      prop: "name",
      isFilterable: true,
      isSortable:true,
      cell: (row) => (
        <Link to={`/productview/${row.id}`} state={row}>
          {capitalizeWords(row.name)}
        </Link>
      ),
    },
    { title: "Status", prop: "status", isFilterable: true, isSortable:true, },
    { title: "Type", prop: "type", isFilterable: true, isSortable:true, },
    {
      title: "Barcode",
      prop: "barcode",
      cell: (row) => <BarcodeCell id={row.id} value={row.barcode} />,
    },
    { title: "Description", prop: "description", isFilterable: true 
    
    },
    { title: "Quantity", prop: "quantity", isFilterable: true, isSortable:true, },
    { title: "Company", prop: "company_name", isFilterable: true, isSortable:true, },
    {
      title: "Image",
      prop: "imageUrl",
      cell: (row) => (
        row?.fileid && (
          <img
            src={`/ibs_ibirds/${row?.id}/${row?.fileid}.${row?.title?.split(".")[1]}`}
            alt="Product"
            title="Click to view all images"
            style={{ width: "80px", height: "auto", cursor: "pointer", borderRadius: "4px" }}
            onClick={() => navigate(`/productview/${row.id}`, { state: row })}
          />
        )
      ),
    }
    
  ];

  return (
    <Container>
      <div style={{ textAlign: "center" }}>
        {isScannerVisible && (
          <>
            <BarcodeScannerComponent
              width={250}
              height={250}
              facingMode="environment"
              onUpdate={(err, result) => {
                if (result){
                  setBarcodeRead(result.text);
                  setScannerVisible(false);
                }
                else {
                  setBarcodeRead("Not Found");
                  // setScannerVisible(false);
                }
              }}
            />
          </>
        )}
      </div>

      <Row className="g-0">
        <Col lg={12}>
          <DatatableWrapper
            body={products}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 10,
                options: [5, 10, 15, 20],
              },
            }}
          >
            <Row className="mb-4">
              <Col xs={12} lg={4} sm={4} md={7} className="d-flex flex-col justify-content-end align-items-end">
                <Filter />
              </Col>
              <Col xs={12} lg={4} sm={6} md={5} className="products-Pagination d-flex flex-col align-items-start">
                <PaginationOptions labels={{ beforeSelect: " " }} />
                <div className="mt-2">
                  <InfoPill
                    className="d-flex flex-col justify-content-start align-items-start"
                    left="Total Products"
                    right={products.length || 0}
                  />
                </div>
              </Col>
              <Col xs={12} sm={2} lg={4} md={12} className="mt-4 products-btn flex-col align-items-center gap-1">
                <Button className="btn-sm scanButton" variant="outline-primary" onClick={handleScanButton}>Scan Barcode</Button>
                {(userInfo?.userrole === "ADMIN" || can_create_inventory) && 
                  <>
                    <Button className="btn-sm custom-btn-css-add-new-record" variant="outline-primary" onClick={() => navigate("/checkin")}>Check In</Button>
                    <Button className="btn-sm custom-btn-css-add-new-record" variant="outline-primary" onClick={() => navigate("/checkout")}>Check Out</Button>
                  </>
                }
                {(userInfo?.userrole === "ADMIN" || can_create) && 
                  (<Button className="btn-sm custom-btn-css-add-new-record" variant="outline-primary" onClick={createProducts}>
                    New Product
                  </Button>
                )}
              </Col>
            </Row>
            <Table striped className="productTable" responsive>
              <TableHeader />
              <TableBody />
            </Table>
            <Pagination />
          </DatatableWrapper>
        </Col>
      </Row>
    </Container>
  );
};
export default Products;
